var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/OnelifeResourceCenterTrigger.tsx
import { forwardRef, useLayoutEffect, useState } from "react";
import { Button } from "@onemedical/rna";
import { jsx } from "react/jsx-runtime";
var BADGE_CLASS = "_pendo-resource-center-badge-container";
var RESOURCE_CENTER_ID = "pendo-resource-center-container";
var OnelifeResourceCenterTrigger = forwardRef((props, ref) => {
  const [isBadgePresent, updateBadgePresence] = useState(true);
  useLayoutEffect(() => updateBadgePresence(document.getElementsByClassName(BADGE_CLASS).length > 0), []);
  const [isResourceCenterOpen, updateResourceCenterState] = useState(false);
  useLayoutEffect(() => updateResourceCenterState(!isBadgePresent && document.getElementById(RESOURCE_CENTER_ID) != null), [isBadgePresent]);
  useLayoutEffect(() => {
    const mutationObserver = new MutationObserver(() => {
      const isBadgeInDOM = document.getElementsByClassName(BADGE_CLASS).length > 0;
      updateBadgePresence(isBadgeInDOM);
      if (isBadgeInDOM)
        return;
      const isResourceCenterInDOM = document.getElementById(RESOURCE_CENTER_ID) != null;
      updateResourceCenterState(isResourceCenterInDOM);
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
    return () => mutationObserver.disconnect();
  }, []);
  const Trigger = /* @__PURE__ */ jsx(Button, __spreadProps(__spreadValues({ ref, onDark: true, variant: "icon", size: "medium", "aria-label": "Open Resource Center" }, props), { id: "onelife-resource-center-trigger", "aria-expanded": isResourceCenterOpen, children: /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14 0.666626\n            C6.63544 0.666626 0.666687 6.63538 0.666687 14\n            C0.666687 21.3645 6.63544 27.3333 14 27.3333\n            C21.3646 27.3333 27.3334 21.3645 27.3334 14\n            C27.3334 6.63538 21.3646 0.666626 14 0.666626Z\n            M14 24.8333\n            C8.02606 24.8333 3.16669 19.9734 3.16669 14\n            C3.16669 8.02652 8.02606 3.16663 14 3.16663\n            C19.974 3.16663 24.8334 8.02652 24.8334 14\n            C24.8334 19.9734 19.974 24.8333 14 24.8333ZM14 18.1666\n            C13.0625 18.1666 12.3334 18.8958 12.3334 19.8333\n            C12.3334 20.7708 13.0156 21.5 14 21.5\n            C14.8906 21.5 15.6667 20.7708 15.6667 19.8333\n            C15.6667 18.8958 14.8906 18.1666 14 18.1666Z\n            M15.724 7.33329\n            H13.0625C11.0313 7.33329 9.41669 8.94788 9.41669 10.9791\n            C9.41669 11.6562 9.9896 12.2291 10.6667 12.2291\n            C11.3438 12.2291 11.9167 11.6562 11.9167 10.9791\n            C11.9167 10.3541 12.3906 9.83329 13.0156 9.83329\n            H15.6771C16.349 9.83329 16.9167 10.3541 16.9167 10.9791\n            C16.9167 11.3958 16.7084 11.7135 16.3438 11.9218\n            L13.375 13.7395\n            C12.9584 14 12.75 14.4166 12.75 14.8333\n            V15.6666C12.75 16.3437 13.3229 16.9166 14 16.9166\n            C14.6771 16.9166 15.25 16.3437 15.25 15.6666\n            V15.5625L17.599 14.1041\n            C18.6927 13.427 19.3698 12.2291 19.3698 10.9791\n            C19.4167 8.94788 17.8021 7.33329 15.724 7.33329Z",
      fill: "currentColor"
    }
  ) }) }));
  return isBadgePresent ? null : Trigger;
});
export {
  OnelifeResourceCenterTrigger
};
